<template>
  <div ref="myEcharts" :style="{ height, width }"></div>
</template>
<script>
import { ref, onMounted } from "vue";
import * as echarts from "echarts";
// // import 'echarts-liquidfill';

export default {
  name: "baseBar",
  props: {
    width: {
      type: String,
      default: "100%",
    },
    height: {
      type: String,
      default: "100%",
    },
    left2Data: {
      type: Object,
      default: () => {},
    },
  },
  setup(props) {
    // console.log(props);
    const myEcharts = ref(null);
    const chart = new InitChart(props, myEcharts);
    onMounted(() => {
      // console.log(props)
      chart.init(props.left2Data, props.name, props.color);
    });
    return {
      myEcharts,
    };
  },
};
class InitChart {
  constructor(props, myEcharts) {
    this.props = props;
    this.myEcharts = myEcharts;
    this.state = {
      chart: null,
    };
  }

  init() {
    this.state.chart && this.destory();
    this.state.chart = echarts.init(this.myEcharts.value);

    this.state.chart.setOption({
      title: {
        text: "智能灌溉", // 标题文本
        left: "center", // 居中对齐
        bottom: "5%", // 设置距离底部的距离
        textStyle: {
          color: "#fff", // 文本颜色
          fontSize: 36, // 字体大小
        },
      },

      series: [
        {
          type: "liquidFill",
          shape: "circle",
          radius: "70%",
          center: ["50%", "50%"],
          data: [0.6, 0.5, 0.4],
          // 球体配置
          outline: {
            borderDistance: 0,
            itemStyle: {
              borderWidth: 5,
              borderColor: "#38CA83",
              shadowBlur: 20,
              shadowColor: "#0CCF97",
            },
          },

          color: ["rgba(50, 255, 238, .6)", "rgba(154, 255, 247, .6)"],

          backgroundStyle: {
            color: "transparent",
          },

          label: {
            show: true,
            textStyle: {
              color: "#12786f",
              insideColor: "#12786f",
              fontSize: 36,
            },
          },
          label: {
            show: true,
            textStyle: {
              color: "#12786f",
              insideColor: "#12786f",
              fontSize: 36,
            },
            formatter: (params) => {
              return `${(params.value * 100).toFixed(0)}%\n {a|百分比}`;
            },
            rich: {
              a: {
                fontSize: 36,
              },
            },
          },
        },
      ],
    });
    window.addEventListener("resize", () => {
      this.state.chart.resize();
    });
  }

  destory() {
    this.state.chart.dispose();
    window.removeEventListener("resize", () => {
      console.log("事件移除");
    });
  }
}
</script>
<style lang="less"></style>
